<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="25%"
    center
    class="Dialog"
    title="选择业务类别"
  >
    <div class="dialog-content">
      <el-select v-model="value" placeholder="请选择业务类别">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="chooseBusinessHandler"
          >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  // , tableList

  export default {
    props: {},
    data() {
      return {
        load: false,
        options: [
          {
            value: '贸易',
            label: '贸易',
          },
          {
            value: '多式联运',
            label: '多式联运',
          },
          {
            value: '园区仓储',
            label: '园区仓储',
          },
          {
            value: '园区物业',
            label: '园区物业',
          },
          {
            value: '监管单',
            label: '监管单',
          },
          {
            value: '城矿',
            label: '城矿',
          },
        ],
        value: '',
        visible: false,
      };
    },

    mounted() {},
    methods: {
      openDialog() {
        this.visible = true;
      },
      chooseBusinessHandler() {
        if (!this.value) {
          this.$message.error('业务类别不能为空');
          return;
        }
        this.$emit('chooseBusinessHandler', this.value);
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
  .dialog-content {
    display: flex;
    justify-content: center;
  }
</style>
